// extracted by mini-css-extract-plugin
export default {"timetableStyle":"styles_timetableStyle__9sqv+","periodName":"styles_periodName__D0BvJ","periodCell":"styles_periodCell__0rdd0"};